import React from "react";
import "./Info.css";

const randomImages = [
  "https://res.cloudinary.com/di82vlbpn/image/upload/v1764970356/Google_AI_Studio_2025-12-05T21_31_44.097Z_emmwmf.png",
  "https://res.cloudinary.com/di82vlbpn/image/upload/v1764970611/Google_AI_Studio_2025-12-05T21_36_29.113Z_zbqfhc.png",
  
  
];

const Info = () => {
  return (
    <div className="info-section">
      <div className="info-text">
        <h4>High-performance aluminium solutions for homes, offices, and commercial spaces.</h4>
        <h2 className="hkk">Aluminium Windows & Doors Sleek, Modern & Built to Last</h2>
        <p>
Upgrade your space with stylish and durable aluminium windows and doors designed for maximum strength, smooth operation, and long-term performance. From precise installation to regular service, we deliver complete solutions tailored to your needs. Perfect for residential, commercial, and industrial projects.        </p>
        <p>
Our aluminium windows and doors are built using high-grade materials for superior strength, thermal performance, and weather resistance. Designed to withstand daily wear and harsh conditions, they offer long-term stability and minimal maintenance.
We specialize in precision installation, ensuring perfect alignment, smooth sliding, and maximum safety ideal for residential, commercial, and high-rise projects.        </p>
      </div>

      <div className="info-images">
        <div className="img-grid">
          {randomImages.map((url, index) => (
            <img key={index} src={url} alt={`Home ${index + 1}`} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Info;
